import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "keyResources",
  initialState: {
    keyResourceList: [],
    keyResourceRequest:{},
    keyResource:{},
  },
  reducers: {
    loadKeyResources: () => {},
    loadKeyResourcesSuccess: (state, action) => {
      state.keyResourceList = action.payload.data;
    },
    loadKeyResourcesFailure: () => {},
    loadKeyResource: () => {},
    loadKeyResourceSuccess: (state, action) => {
      state.keyResource = action.payload.data;
    },
    setKeyResourceRequest:(state, action) => {
      state.keyResourceRequest = action.payload;
    },
    addKeyResource :() => {},
    editKeyResource :() => {},
  },
});

export const {
  loadKeyResources,
  loadKeyResourcesSuccess,
  loadKeyResourcesFailure,
  addKeyResource,
  editKeyResource,
  setKeyResourceRequest,
  loadKeyResource,
  loadKeyResourceSuccess
} = counterSlice.actions;

export default counterSlice.reducer;

export const getKeyResources = (state) => state.keyResources.keyResourceList;

export const getKeyResource = (state) => state.keyResources.keyResource;

export const getKeyResourceRequest = (state) => state.keyResources.keyResourceRequest;


